import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState<string | null>(null);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileMenuOpen(false);
    setActiveDropdown(null);
  }, [location.pathname]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-100/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              五一<span className="text-primary-500">黑料</span>网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500 bg-primary-500/10'
                  : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.slice(0, 5).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500 bg-primary-500/10'
                    : 'text-foreground-700 hover:text-foreground-950 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <div className="relative">
              <button
                onMouseEnter={() => setActiveDropdown('more')}
                onMouseLeave={() => setActiveDropdown(null)}
                className="px-4 py-2 text-sm font-medium rounded-lg transition-colors whitespace-nowrap text-foreground-700 hover:text-foreground-950 hover:bg-background-200 flex items-center gap-1"
              >
                更多 <i className="ri-arrow-down-s-line text-xs"></i>
              </button>
              {activeDropdown === 'more' && (
                <div
                  className="absolute top-full right-0 mt-1 bg-background-100 border border-background-300/60 rounded-lg py-2 w-40 shadow-lg"
                  onMouseEnter={() => setActiveDropdown('more')}
                  onMouseLeave={() => setActiveDropdown(null)}
                >
                  {categories.slice(5).map((cat) => (
                    <Link
                      key={cat.slug}
                      to={`/category/${cat.slug}`}
                      className="block px-4 py-2 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 whitespace-nowrap"
                    >
                      {cat.name}
                    </Link>
                  ))}
                  <div className="border-t border-background-300/60 my-1"></div>
                  <Link
                    to="/about"
                    className="block px-4 py-2 text-sm text-foreground-700 hover:text-foreground-950 hover:bg-background-200 whitespace-nowrap"
                  >
                    关于我们
                  </Link>
                </div>
              )}
            </div>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              商务合作
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <i className={`ri-${isMobileMenuOpen ? 'close' : 'menu'}-line text-xl`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-background-100 border-t border-background-300/60">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 rounded-lg hover:bg-background-200 whitespace-nowrap">
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 rounded-lg hover:bg-background-200 whitespace-nowrap"
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="px-3 py-2.5 text-sm text-foreground-700 hover:text-foreground-950 rounded-lg hover:bg-background-200 whitespace-nowrap">
              关于我们
            </Link>
            <Link to="/about" className="mt-2 px-5 py-2.5 text-sm font-medium text-center rounded-full bg-primary-500 text-background-50 hover:bg-primary-600 whitespace-nowrap">
              商务合作
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}